var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseView',[_c('Navbar',{attrs:{"back-click":"","title":_vm.title},on:{"back":_vm.handleBack}}),_c('FormWrapper',{staticClass:"py-3"},[_c('Nav',{staticClass:"mb-4",attrs:{"items":_vm.items}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }